import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserSettingsService } from 'api';

export const getUserSettings = createAsyncThunk('userSettings/getUserSettings', async () => {
	return await UserSettingsService.get();
});
